const Footer = () => {
	return (
		<footer>
			<p>Powered by <a href="https://drive-colorado.com" target="_blank">Drive Colorado</a> &copy;{new Date().getFullYear()}</p>
		</footer>
	)
}

export default Footer